<template>
    <w-btn
        v-if="show"
        color="purple"
        :loading="loading"
        :text="$t('common.archive')"
        icon="mdi-archive"
        @press="press"
    />
</template>

<script>
export default {
    name: 'WBtnArchive',
    props: {
        show: Boolean,
        loading: Boolean,
    },
    emits: ['press'],
    setup(props, {emit}) {
        function press() {
            emit('press');
        }

        return {
            press,
        }
    }
}
</script>

<style scoped>

</style>